export const FileIcon = ({
  color = '#0E4EA2',
  width = 24,
  height = 24,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6 2.00006C5.46957 2.00006 4.96086 2.21077 4.58579 2.58584C4.21071 2.96092 4 3.46963 4 4.00006V20.0001C4 20.5305 4.21071 21.0392 4.58579 21.4143C4.96086 21.7893 5.46957 22.0001 6 22.0001H18C18.5304 22.0001 19.0391 21.7893 19.4142 21.4143C19.7893 21.0392 20 20.5305 20 20.0001V8.00006L14 2.00006H6ZM6 4.00006H13L18 9.00006V20.0001H6V4.00006Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2346 2.1523C12.982 1.84274 13.8422 2.01385 14.4142 2.58584L19.4142 7.58584C19.9862 8.15784 20.1573 9.01808 19.8478 9.76543C19.5382 10.5128 18.8089 11.0001 18 11.0001H14C12.3431 11.0001 11 9.65691 11 8.00006V4.00006C11 3.19113 11.4873 2.46186 12.2346 2.1523ZM13 4.00006V8.00006C13 8.55234 13.4477 9.00006 14 9.00006H18L13 4.00006Z"
        fill={color}
      />
    </svg>
  );
};
